import { IS_USING_ALD_MSG_COLLECTION, NG_WORD } from "constants/streaming";
import { streamingState } from "modules/streaming";
import type { ResGetStreamingKey } from "@spwn/types/functions";

/**
 * check if user can watch video
 * @param streamingKey
 * @param video
 */
export const canWatchVideo = (
  streamingKey: ResGetStreamingKey,
  vid: string,
  // @ts-expect-error TS2322
  ticketId: string = null
) => {
  if (streamingKey.isError) {
    return false;
  }
  // @ts-expect-error TS18048
  if (ticketId !== null && !streamingKey.ticketIds.includes(ticketId)) {
    return false;
  }
  // if streaming has started
  return (
    (Boolean(streamingKey.cookies) &&
      // @ts-expect-error TS18048
      streamingKey.cookies.hasOwnProperty(vid)) ||
    // if streaming is free open
    (streamingKey.hasTickets && Boolean(streamingKey.url)) ||
    // if streaming page is before open or streaming has started
    // @ts-expect-error TS18048
    (Boolean(streamingKey.videoIds) && streamingKey.videoIds.includes(vid))
  );
};

/**
 * check if goods page is present
 * HOTFIX ライブコマースだけかどうかのために使用
 * @param eventId
 */
export const HAS_GOODS_PAGE = (eventId: string) => {
  switch (eventId) {
    case "200816-boymen-newsingleevent":
    case "200822-boymen-newsingleevent":
    case "200822-boymen-newsingleevent2":
      return false;
    default:
      return true;
  }
};

/**
 * save current playing time to session storage
 * @param vid
 * @param currentTime
 */
export const saveCurrentTimeToSessionStorage = (
  vid: string,
  currentTime: string
) => {
  // const now = new Date();
  // now.setTime(now.getTime() + (5 * 24 * 60 * 60 * 1000)); // store for 5 days
  // const expires = `expires=${now.toUTCString()}`
  // document.cookie = `${vid}=${currentTime};${expires};path=/`
  sessionStorage.setItem(`playHeadPosition${vid}`, currentTime);
};

/**
 * load play head from session storage
 * @param vid
 */
export const loadCurrentTimeFromSessionStorage = (vid: string): number => {
  const t = sessionStorage.getItem(`playHeadPosition${vid}`);
  if (t) {
    return Math.max(Number(t), 0);
  } else {
    return 0;
  }
};

/**
 * 禁止ワードが含まれているかチェックする
 * @param { string } value
 * @return boolean
 */
export const isForbiddenWord = (value: string, ngWords: string[]): boolean => {
  try {
    const ngWordsList = NG_WORD.concat(ngWords).map(escapeRegExp);

    // make pattern like [(a)|(abc)|(cd)]
    const pattern = "(" + ngWordsList.join(")|(") + ")";

    // g: global, i: ignore case
    const rgx = new RegExp(pattern, "gi");

    return rgx.test(value);
  } catch (error) {
    // NGワード設定側のバリデーションが完璧ではないので
    // 仮にエラーになったら握り潰してコメントを許容する。エラー通知はさせたい。
    console.error(error);
    return false;
  }
};

/**
 * 特殊文字をエスケープする
 * @see https://developer.mozilla.org/ja/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
 */
const escapeRegExp = (string: string) => {
  // $&はマッチした部分文字列全体を意味します
  return string.replace(/[.*+?^=!:${}()|[\]\/\\]/g, "\\$&"); // eslint-disable-line no-useless-escape
};

/**
 * 配信ページに入ったときに配信する動画を決定する
 * ticketが2つ以上videoを持っている場合、配信中 > 配信前 の優先度で、一番初めの要素のvideoIdを採用する
 * @param eventVideoMap
 * @param videoIds
 */
export const extractDefaultVideoId = (
  eventVideoMap: streamingState["eventVideoMap"],
  videoIds: string[]
) => {
  const openVideoIds = [];
  const closedVideoIds = [];
  for (const videoId of videoIds) {
    const video = eventVideoMap?.[videoId];
    if (video?.isOpen === undefined || video?.isOpen) {
      openVideoIds.push(videoId);
    } else {
      closedVideoIds.push(videoId);
    }
  }
  return openVideoIds.length > 0 ? openVideoIds[0] : closedVideoIds[0];
};

export const getCommentCollectionPath = (
  eventId: string,
  videoId: string,
  isShardingEnabled: boolean | undefined,
  shardId: number | null | undefined
) => {
  if (isShardingEnabled) {
    return `/chat/${eventId}/videoIds/${videoId}/shards/${
      shardId ?? 0
    }/msgs` as const;
  }
  return IS_USING_ALD_MSG_COLLECTION(eventId)
    ? (`/chat/${eventId}/msgs` as const)
    : (`/chat/${eventId}/videoIds/${videoId}/msgs` as const);
};
